import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cp-application-help',
    templateUrl: './application-help.component.html',
    styleUrls: ['./application-help.component.css'],
    standalone: false
})
export class ApplicationHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
